module.exports = "pegasus/assets/graycircle-instagram.png";